import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';

@Component({
  selector: 'app-mobile-location',
  templateUrl: './mobile-location.component.html',
  styleUrls: ['./mobile-location.component.css']
})
export class MobileLocationComponent extends BaseListCtl {

  datePickerConfig : Partial<BsDatepickerConfig>;

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.MOBILELOCATION,locator,route);

    this.datePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: true,
        
        maxDate: new Date(),
        dateInputFormat: 'DD/MM/YYYY'
      });

  }

  populateForm(form, data) {
    form.id = data.id;
    form.dateTime=data.dateTime;
    form.endTime=data.endTime;
    form.userId=data.userId;
    form.userName=data.userName;
    form.latitude=data.latitude;
    form.longitude=data.longitude;
    form.mobileId=data.mobileId;
    
    console.log('----->',data);
  }

  
}
